// extracted by mini-css-extract-plugin
export default {"link":"Link-link___65S0j"};